import umbraco from '~/lib/api/umbraco';
import { UmbracoTypes } from '~/lib/data-contract';
import { getUrl } from '~/services/umbraco/utils';

export default function getNavigation(signal: AbortSignal | undefined, asPath: string) {
    const url = getUrl(`/content/frame/navigation`);

    url.searchParams.append('url', asPath);

    return umbraco.get(url, { signal }).json<UmbracoTypes.INavigationNode>();
}
